
    // IMPORTS
    import { computed, defineComponent, PropType } from 'vue'
    import router from '@/router'
    import { buildLocalization } from '@/util'
    import { useUserStore } from '@/store/user'
    import { useShoppingCartStore } from '@/store/shoppingCart'

    import LanguageSelector from '@/components/common/language-selector.vue'
    import CurrencySelector from '@/components/common/currency-selector.vue'
    import { Button } from '@progress/kendo-vue-buttons'
    import { Badge } from '@progress/kendo-vue-indicators'
    import MyIcon from '@/components/common/my-icon.vue'

    import { useBrowserStateStore } from '@/store/browserState'

    export default defineComponent({
        name: 'topBannerToolbar',

        components: {
            LanguageSelector,
            CurrencySelector,
            'k-button': Button,
            Badge,
            MyIcon
        },

        props: {
            showLogOff: { type: Boolean as PropType<boolean>, required: false, default: () => false },
        },

        setup() {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const { localize } = buildLocalization()
            const userStore = useUserStore()
            const shoppingCartStore = useShoppingCartStore()
            const browserState = useBrowserStateStore()

            /********************************************************************************************************************
             PUBLIC DATA
             ********************************************************************************************************************/
            const publicData = { }

            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const userData = computed(() => userStore.userData)
            const isAdmin = computed(() => userStore.isAdmin)
            const email = computed(() => userData.value?.currentUser)
            const currentUser = computed(() => userData.value?.partnerAccount.userAccounts.find(u => u.email == email.value))
            const fullName = computed(() => currentUser.value == null
                ? null
                : `${currentUser.value?.firstName} ${currentUser.value?.lastName}`
            )
            const shoppingCart = computed(() => currentUser.value == null
                ? null
                : shoppingCartStore.shoppingCart
            )
            const shoppingCartItemCount = computed(() => shoppingCart.value?.items.reduce((acc, item) => acc + item.count, 0))

            const isSmallScreen = computed(() => browserState.isSmallScreen)

            const computedData = {
                userData,
                isAdmin,
                email,
                currentUser,
                fullName,
                shoppingCart,
                shoppingCartItemCount,
                isSmallScreen
            }

            /********************************************************************************************************************
             PUBLIC METHODS AND EVENT HANDLERS
             ********************************************************************************************************************/
            function onClickShoppingCart() {
                router.push({ name: 'shopping-cart' })
            }

            const publicMethods = { localize, onClickShoppingCart }
            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...publicData, ...computedData, ...publicMethods }
        }
    });
